import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@spothero/ui/button';
import Price from 'common/price/Price';

const PurchaseButton = ({
    price,
    loading,
    disabled,
    onReserveClick,
    showPrice,
    showAdminBorder,
    isCTAVariation
}) => {
    const isPositivePrice = (price > 0);
    const buttonText = (isPositivePrice) ? 'Pay and Reserve' : 'Reserve Now';
    const purchaseBtnClasses = classNames(
        'PurchaseButton',
        {'PurchaseButton-accelerate': isCTAVariation},
        {'admin-border-button': showAdminBorder},
    );

    /* eslint-disable react/jsx-max-props-per-line */
    return (
        <Fragment>
            <Button
                color="primary"
                className={purchaseBtnClasses}
                loading={loading}
                disabled={disabled}
                onClick={onReserveClick}
            >
                {(isPositivePrice && showPrice) &&
                    <Fragment>
                        <Price amount={price} />
                        <span className="Button-separator" />
                    </Fragment>
                }
                {buttonText}
            </Button>
            <small className="PurchaseButton-legal">
                By selecting &quot;{buttonText}&quot; you are agreeing to SpotHero&apos;s <a target="_blank" href="/terms-of-use">Terms and Conditions</a>.
            </small>
        </Fragment>
    );
    /* eslint-enable react/jsx-max-props-per-line */
};

PurchaseButton.propTypes = {
    price: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    showPrice: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    showAdminBorder: PropTypes.bool,
    isCTAVariation: PropTypes.bool,
    onReserveClick: PropTypes.func.isRequired
};

export default PurchaseButton;
